import {
    LOADING_SCREEN_SHOW, LOADING_SCREEN_HIDE,
    INSPECTION_PHOTO_STEP_SCREEN_SHOW, INSPECTION_PHOTO_STEP_SCREEN_HIDE, FULLSCREEN_CAMERA_SHOW, FULLSCREEN_CAMERA_HIDE, MAINTENANCE_SCREEN_SHOW, MAINTENANCE_SCREEN_HIDE, SALES_CHAT_LOADING_SCREEN_SHOW, SALES_CHAT_LOADING_SCREEN_HIDE, POLICY_VIEW_SUCCESS_SCREEN_SHOW, POLICY_VIEW_SUCCESS_SCREEN_HIDE, POLICY_LOAD_VIEW_SCREEN_SHOW, POLICY_LOAD_VIEW_SCREEN_HIDE,
    UPDATE_POLICY_LOADER_SCREEN_HIDE, UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE, UPDATE_POLICY_LOADER_SCREEN_SHOW, UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW, SELF_INSPECTION_SCREEN_HIDE, SELF_INSPECTION_SCREEN_SHOW, IVERI_SUCCESS_SCREEN_SHOW, IVERI_SUCCESS_SCREEN_HIDE, FNOL_TAKE_PHOTO_SCREEN_HIDE, FNOL_TAKE_PHOTO_SCREEN_SHOW, CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW, CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE, QUOTE_LOADING_SCREEN_SHOW, QUOTE_LOADING_SCREEN_HIDE
} from './../constants/constants';

export const initialState = {
    loadingScreenVisible: false,
    salesChatLoadingScreenVisible: false,
    inspectionPhotoStepVisible: false,
    fullscreenCameraVisible: false,
    maintenanceScreenVisible: false,
    policyLoadViewScreenVisible: false,
    policyViewSuccessScreenVisible: false,
    updatePolicyLoadViewVisible: false,
    updatePolicySuccessLoadVisible: false,
    selfInspectStepsVisible: false,
    iveriSuccessVisible: false,
    fnolTakePhotoVisible: false,
    claimsV2TakePhotoVisible : false,
    quoteLoadingScreenVisible: false,
}

const fullscreenReducer = function loadingScreen(state = initialState, action) {
    let returnedState = state;
    switch (action.type) {
        case LOADING_SCREEN_SHOW:
            returnedState = {
                ...state,
                loadingScreenVisible: true
            }
            break;
        case LOADING_SCREEN_HIDE:
            returnedState = {
                ...state,
                loadingScreenVisible: false
            }
            break;
        case SALES_CHAT_LOADING_SCREEN_SHOW:
            returnedState = {
                ...state,
                salesChatLoadingScreenVisible: true
            }
            break;
        case SALES_CHAT_LOADING_SCREEN_HIDE:
            returnedState = {
                ...state,
                salesChatLoadingScreenVisible: false
            }
            break;
        case INSPECTION_PHOTO_STEP_SCREEN_SHOW:
            returnedState = {
                ...state,
                inspectionPhotoStepVisible: true
            }
            break;
        case INSPECTION_PHOTO_STEP_SCREEN_HIDE:
            returnedState = {
                ...state,
                inspectionPhotoStepVisible: false
            }
            break;
        case FULLSCREEN_CAMERA_SHOW:
            returnedState = {
                ...state,
                fullscreenCameraVisible: true
            }
            break;
        case FULLSCREEN_CAMERA_HIDE:
            returnedState = {
                ...state,
                fullscreenCameraVisible: false
            }
            break;

        case MAINTENANCE_SCREEN_SHOW:
            returnedState = {
                ...state,
                maintenanceScreenVisible: true
            }
            break;
        case MAINTENANCE_SCREEN_HIDE:
            returnedState = {
                ...state,
                maintenanceScreenVisible: false
            }
            break;

        case POLICY_VIEW_SUCCESS_SCREEN_SHOW:
            returnedState = {
                ...state,
                policyViewSuccessScreenVisible: true
            }
            break;
        case POLICY_VIEW_SUCCESS_SCREEN_HIDE:
            returnedState = {
                ...state,
                policyViewSuccessScreenVisible: false
            }
            break;

        case POLICY_LOAD_VIEW_SCREEN_SHOW:
            returnedState = {
                ...state,
                policyLoadViewScreenVisible: true
            }
            break;
        case POLICY_LOAD_VIEW_SCREEN_HIDE:
            returnedState = {
                ...state,
                policyLoadViewScreenVisible: false
            }
            break;

        case UPDATE_POLICY_LOADER_SCREEN_SHOW:
            returnedState = {
                ...state,
                updatePolicyLoadViewVisible: true
            }
            break;
        case UPDATE_POLICY_LOADER_SCREEN_HIDE:
            returnedState = {
                ...state,
                updatePolicyLoadViewVisible: false
            }
            break;

        case UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW:
            returnedState = {
                ...state,
                updatePolicySuccessLoadVisible: true
            }
            break;
        case UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE:
            returnedState = {
                ...state,
                updatePolicySuccessLoadVisible: false
            }
            break;
        case FNOL_TAKE_PHOTO_SCREEN_SHOW:
            returnedState = {
                ...state,
                fnolTakePhotoVisible: true
            }
            break;
        case FNOL_TAKE_PHOTO_SCREEN_HIDE:
            returnedState = {
                ...state,
                fnolTakePhotoVisible: false
            }
            break;
        case CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW:
            returnedState = {
                ...state,
                claimsV2TakePhotoVisible: true
            }
            break;
        case CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE:
            returnedState = {
                ...state,
                claimsV2TakePhotoVisible: false
            }
            break;
        case SELF_INSPECTION_SCREEN_SHOW:
            returnedState = {
                ...state,
                selfInspectStepsVisible: true
            }
            break;
        case SELF_INSPECTION_SCREEN_HIDE:
            returnedState = {
                ...state,
                selfInspectStepsVisible: false
            }
            break;
        case IVERI_SUCCESS_SCREEN_SHOW:
            returnedState = {
                ...state,
                iveriSuccessVisible: true
            }
            break;
        case IVERI_SUCCESS_SCREEN_HIDE:
            returnedState = {
                ...state,
                iveriSuccessVisible: false
            }
            break;
        case QUOTE_LOADING_SCREEN_SHOW:
            returnedState = {
                ...state,
                quoteLoadingScreenVisible: true
            }
            break;
        case QUOTE_LOADING_SCREEN_HIDE:
            returnedState = {
                ...state,
                quoteLoadingScreenVisible: false
            }
            break;
        default:
            returnedState = state;
            break;
    }   
    return returnedState;
}

export default fullscreenReducer;